import styled from "styled-components";
import { motion } from "motion/react";
import SimpleBar from "simplebar-react";

export const Modal = styled.div`
  position: relative;
  width: 100%;
  max-width: 496px;
`;

export const ModalView = styled( motion.div )`
  display: flex;
  min-width: 0;
  flex-direction: column;
  background-color: ${({ theme }) => theme.palette.elevated };
  color: ${({ theme }) => theme.colors.text.default };
  box-shadow: ${({ theme }) => theme.shadow.default };
  border: 1px solid ${({ theme }) => theme.palette.border };
  border-top-right-radius: ${({ theme }) => theme.border_radius.large }px;
  border-top-left-radius: ${({ theme }) => theme.border_radius.large }px;
`;

export const ModalHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.x_medium }px;
  padding-bottom: 0;

  & > span {
    flex: 1;
    margin-left: ${({ theme }) => theme.spacing.x_medium }px;

    min-height: ${({ theme }) => theme.font_size.x_large }px;
    font-size: ${({ theme }) => theme.font_size.x_large }px;
    line-height: ${({ theme }) => theme.font_size.x_large }px;
    font-weight: ${({ theme }) => theme.typography.weight.semibold };
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.tight };
    color: ${({ theme }) => theme.colors.text.default };
  }
`;

export const ModalBody = styled( SimpleBar )`
  width: 100%;
  min-width: 0;
  margin-top: ${({ theme }) => theme.spacing.x_medium }px;
  overflow-y: auto;
  padding: ${({ theme }) => theme.spacing.x_medium }px;
  padding-top: 0;

  & .simplebar-content-wrapper {
    overflow-x: hidden !important;
  }

  & .simplebar-content {
    min-width: 0;
  }

  & > .simplebar-track.simplebar-horizontal {
    display: none;
  }
`;

export const MessageTypesView = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.xx_small }px;
  margin-top: ${({ theme }) => theme.spacing.x_small }px;
`;
